import { gql } from '@apollo/client'

export default gql`
    query ordersList(
        $limit: Int!
        $offset: Int
        $isCpqFlagV2Enabled: Boolean = false
    ) {
        me {
            id
            salesOrders(limit: $limit, offset: $offset) {
                totalCount
                items {
                    ... on SalesOrder {
                        id
                        isReorderAllowed
                        isBusinessAccountDiscountApplied
                        appliedBusinessAccountDiscountPercent
                        name
                        deliveryStatus
                        shippedBy
                        createdAt
                        totalAmount
                        downloadAllFilesUri
                        fictivShipmentMethod
                        fictivOrderUpdatedToDdp
                        team {
                            id
                            name
                        }
                        salesOrderLines(limit: 4) {
                            totalCount
                            productCount
                            items {
                                id
                                revision {
                                    id
                                    thumbnailUri
                                }
                                processes {
                                    id
                                    platformProcessId
                                    color
                                    texture
                                    thickness
                                    processNotes
                                    additionalSpecifications {
                                        color
                                        texture
                                        thickness
                                    }
                                    dfmNotes {
                                        color
                                        process
                                        texture
                                        thickness
                                    }
                                }
                                htsCodeSubmitted
                            }
                            parts {
                                id
                                revision {
                                    id
                                    thumbnailUri
                                }
                                processes {
                                    id
                                    platformProcessId
                                    color
                                    texture
                                    thickness
                                    processNotes
                                    additionalSpecifications {
                                        color
                                        texture
                                        thickness
                                    }
                                    dfmNotes {
                                        color
                                        process
                                        texture
                                        thickness
                                    }
                                }
                                htsCodeSubmitted
                            }
                        }
                        paymentDetails {
                            paymentType
                            purchaseOrderNumber
                            paidBy {
                                id
                            }
                        }
                        project {
                            id
                            isSecurePlus
                            name
                        }
                        sourceQuoteType
                        quote {
                            name
                        }
                        quotePdfUrl @include(if: $isCpqFlagV2Enabled)
                        quoteOwnerUser {
                            id
                        }
                    }
                    ... on BasicSalesOrder {
                        id
                        name
                        deliveryStatus
                        shippedBy
                        createdAt
                        totalAmount
                        project {
                            id
                            isSecurePlus
                            name
                        }
                    }
                }
            }
        }
    }
`
export const orderSearch = gql`
    query orderSearch(
        $orderSearchSearchString: String!
        $from: Int!
        $size: Int!
        $isCpqFlagV2Enabled: Boolean = false
    ) {
        orderSearch(
            searchString: $orderSearchSearchString
            from: $from
            size: $size
        ) {
            totalCount
            page {
                total
                totalPages
                pageNumber
                from
                size
            }
            items {
                ... on SalesOrder {
                    id
                    isReorderAllowed
                    name
                    deliveryStatus
                    shippedBy
                    createdAt
                    totalAmount
                    downloadAllFilesUri
                    fictivShipmentMethod
                    fictivOrderUpdatedToDdp
                    team {
                        id
                        name
                    }
                    quotePdfUrl @include(if: $isCpqFlagV2Enabled)
                    salesOrderLines {
                        items {
                            id
                            revision {
                                thumbnailUri
                                __typename
                            }
                            processes {
                                id
                                platformProcessId
                                color
                                texture
                                thickness
                                processNotes
                                additionalSpecifications {
                                    color
                                    texture
                                    thickness
                                }
                                dfmNotes {
                                    color
                                    process
                                    texture
                                    thickness
                                }
                                __typename
                            }
                            __typename
                        }
                        parts {
                            id
                            revision {
                                id
                                thumbnailUri
                                __typename
                            }
                            processes {
                                id
                                platformProcessId
                                color
                                texture
                                thickness
                                processNotes
                                additionalSpecifications {
                                    color
                                    texture
                                    thickness
                                }
                                dfmNotes {
                                    color
                                    process
                                    texture
                                    thickness
                                }
                                __typename
                            }
                            htsCodeSubmitted
                            __typename
                        }
                    }
                    paymentDetails {
                        paymentType
                        purchaseOrderNumber
                        paidBy {
                            id
                        }
                    }
                    quoteOwnerUser {
                        id
                    }
                }
                __typename
            }
        }
    }
`
export const adminUserOrderSearch = gql`
    query AdminUserOrderSearch(
        $searchString: String!
        $from: Int!
        $size: Int!
        $userId: Int
        $isCpqFlagV2Enabled: Boolean = false
    ) {
        adminUserOrderSearch(
            searchString: $searchString
            from: $from
            size: $size
            userId: $userId
        ) {
            totalCount
            page {
                total
                totalPages
                pageNumber
                from
                size
            }
            items {
                ... on SalesOrder {
                    id
                    isReorderAllowed
                    name
                    deliveryStatus
                    fictivEstimatedDeliveryDate
                    shippedBy
                    createdAt
                    totalAmount
                    downloadAllFilesUri
                    fictivShipmentMethod
                    fictivOrderUpdatedToDdp
                    quotePdfUrl @include(if: $isCpqFlagV2Enabled)
                    salesOrderLines {
                        items {
                            id
                            revision {
                                thumbnailUri
                                __typename
                            }
                            __typename
                        }
                        parts {
                            id
                            revision {
                                id
                                thumbnailUri
                                __typename
                            }
                            processes {
                                id
                                platformProcessId
                                color
                                texture
                                thickness
                                processNotes
                                additionalSpecifications {
                                    color
                                    texture
                                    thickness
                                }
                                dfmNotes {
                                    color
                                    process
                                    texture
                                    thickness
                                }
                                __typename
                            }
                            htsCodeSubmitted
                            __typename
                        }
                    }
                    paymentDetails {
                        paymentType
                        purchaseOrderNumber
                    }
                }
                __typename
            }
        }
    }
`
